module.exports = __webpack_public_path__ + "img/builds_pst_ttp.61b3f7dc.jpg";